export default "__VITE_ASSET__DYhE4cm9__"